// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { castToString } from 'helpers/reduxFormFunctions'

// adds more information to the model number because analog modulation scheme types can have the
// same modelNumber but will have different bandwidths/number of channels.
const makeModulationSchemeLabel = ms => {
  // ms or modulationScheme can be null.
  // it shouldn't ever according to DB requirements
  // but RadioSummaryDTO and RadioDetailsDTO technically can have them as null.
  const analogBandwidth = ms?.analogBandwidth || null
  const numAnalogChannels = ms?.numAnalogChannels || null

  // RadioSummaryDTO only has the string value of modulationSchemeDescription
  // however
  // RadioDetailsDTO has this as the entity modulationSchemeDescription
  const modulationSchemeDescription = castToString(
    ms?.modulationSchemeDescription?.modulationSchemeDescription ||
      ms?.modulationSchemeDescription ||
      ''
  )

  const abw = analogBandwidth !== null ? ` ${analogBandwidth} MHz` : ''
  const nac = numAnalogChannels !== null ? ` ${numAnalogChannels} CH` : ''

  return `${modulationSchemeDescription}${abw}${nac}`
}

export default makeModulationSchemeLabel
